import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

const portfolioItems = [
  {
    title: 'Site Vitrine Entreprise',
    badge: 'Site vitrine',
    image: 'https://images.pexels.com/photos/3584973/pexels-photo-3584973.jpeg',
    objective: 'Présenter votre entreprise et attirer de nouveaux clients professionnels',
    idealFor: 'Consultants, agences, services BtoB',
    demoLink: '/demo-vitrine'
  },
  {
    title: 'Boutique E-commerce',
    badge: 'Site e-commerce',
    image: 'https://images.unsplash.com/photo-1594235048794-fae8583a5af5',
    objective: 'Vendre vos produits en ligne et développer votre chiffre d\u2019affaires',
    idealFor: 'Commerçants, créateurs, vendeurs en ligne',
    demoLink: "/demo-ecommerce"
  },
  {
    title: 'Site Artisan',
    badge: 'Site professionnel',
    image: 'https://images.unsplash.com/photo-1606857521015-7f9fcf423740',
    objective: 'Montrer vos réalisations et recevoir des demandes de devis',
    idealFor: 'Plombiers, électriciens, artisans du bâtiment',
    demoLink: "/demo-artisan"
  },
  {
    title: 'Site Restaurant',
    badge: 'Site local',
    image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4',
    objective: 'Présenter votre carte et permettre les réservations en ligne',
    idealFor: 'Restaurants, cafés, traiteurs',
    demoLink: '/demo-restaurant'
  }
];

const Portfolio = () => {
  return (
    <section id="portfolio" className="py-16 sm:py-20 bg-white w-full overflow-hidden">
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1E3A5F] mb-4">
            Exemples de sites que je crée
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto">
            Cliquez sur un exemple pour voir une démo complète
          </p>
        </div>

        {/* Portfolio Grid */}
        <div className="grid sm:grid-cols-2 gap-6 sm:gap-8 mb-12">
          {portfolioItems.map((item, index) => (
            <Card
              key={index}
              className="overflow-hidden hover:shadow-2xl transition-all duration-300 border-2 hover:border-[#FF9933]/30"
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                />
                {/* Badge */}
                <div className="absolute top-4 right-4 bg-[#FF9933] text-white px-3 py-1 rounded-full text-sm font-semibold">
                  {item.badge}
                </div>
              </div>

              {/* Content */}
              <CardContent className="p-6">
                <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">
                  {item.title}
                </h3>
                
                <p className="text-[#FF9933] font-semibold mb-2">
                  🎯 Objectif :
                </p>
                <p className="text-gray-700 mb-3 leading-relaxed">
                  {item.objective}
                </p>
                
                <p className="text-gray-500 text-sm italic mb-4">
                  Idéal pour : {item.idealFor}
                </p>
                
                {/* Demo Link */}
                {item.demoLink ? (
                  <a
                    href={item.demoLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-[#FF9933] hover:text-[#E68A2E] font-semibold transition-colors duration-200"
                  >
                    Voir l'exemple complet
                    <ExternalLink size={16} />
                  </a>
                ) : (
                  <button
                    onClick={() => alert('Cette démo sera bientôt disponible')}
                    className="inline-flex items-center gap-2 text-gray-400 font-semibold cursor-not-allowed"
                  >
                    Voir l'exemple complet
                    <ExternalLink size={16} />
                  </button>
                )}
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Info Box */}
        <div className="bg-blue-50 border-l-4 border-[#FF9933] p-6 rounded-lg max-w-4xl mx-auto">
          <p className="text-[#1E3A5F] text-base sm:text-lg">
            <span className="font-bold">💡</span> Votre site sera unique et adapté à votre activité spécifique. Ces exemples sont là pour vous donner une idée du rendu.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
